import { ProductCategory } from '~/scopes/product/constants'

export const COMPATIBLE_CATEGORIES = [
  ProductCategory.MACBOOK_INTEL,
  ProductCategory.MACBOOK_M,
]

// TODO: Refine types as part of DSB-9146

export const LOCALE_DEFAULT_KEYBOARD: Record<string, string> = {
  'de-at': 'QWERTZ - Deutsch',
  'de-de': 'QWERTZ - Deutsch',
  'el-gr': 'QWERTY - Ελληνική',
  'en-au': 'QWERTY - English',
  'en-gb': 'QWERTY - English',
  'en-ie': 'QWERTY - English',
  'en-us': 'QWERTY - English',
  'es-es': 'QWERTY - Español',
  'es-us': 'QWERTY - Español',
  'fi-fi': 'QWERTY - Suomi',
  'fr-be': 'AZERTY - Français',
  'fr-fr': 'AZERTY - Français',
  'it-it': 'QWERTY - Italiano',
  'ja-jp': 'JIS配列キーボード',
  'nl-nl': 'QWERTY - Nederlands',
  'pt-pt': 'QWERTY - Português',
  'sv-se': 'QWERTY - Svensk',
  'sk-sk': 'QWERTZ - Slovenská',
}
